import { bindCallbacks, statusText } from 'scripts/infrastructure/backends/fake_backend_http/lib/common';

export default class GuideCollectionService {
  constructor(getDatabase, authCache) {
    this.getDatabase = getDatabase;
    this.authCache = authCache;
  }

  findAll(attrs, callback) {
    const cachedAuth = this.authCache.get();

    if (!cachedAuth) {
      return callback(null, { status: 401, statusText: statusText(401) });
    }

    const { orgId } = cachedAuth;
    const guideCollections = this.getDatabase(orgId).guideCollections?.map(({ id, name }) => ({ id, name }));
    callback(null, { status: 200, statusText: statusText(200), response: guideCollections });
  }

  getRoutes() {
    return bindCallbacks(
      {
        '/sidekick/api/guide-collections': {
          GET: this.findAll,
        },
      },
      this
    );
  }
}
